import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createDraft } from "../actions/createDraft.actions";
import { renameDraft } from "../actions/rename-draft.actions";
import { deleteDraft } from "../actions/delete-draft.actions";

const MY_DRAFTS_KEY = ["page-builder-my-drafts"] as const;
const ME_KEY = ["page-builder-me"] as const;

export function useDraftsMutations() {
    const qc = useQueryClient();

    const create = useMutation({
        mutationFn: createDraft,
        onSuccess: async () => {
            await Promise.all([
                qc.refetchQueries({ queryKey: MY_DRAFTS_KEY, type: "all" }),
                qc.refetchQueries({ queryKey: ME_KEY, type: "all" }),
            ]);
        },
    });

    const rename = useMutation({
        mutationFn: renameDraft,
        onSuccess: async () => {
            await Promise.all([
                qc.refetchQueries({ queryKey: MY_DRAFTS_KEY, type: "all" }),
                qc.refetchQueries({ queryKey: ME_KEY, type: "all" }),
            ]);
        },
    });

    const remove = useMutation({
        mutationFn: deleteDraft,
        onSuccess: async () => {
            await Promise.all([
                qc.refetchQueries({ queryKey: MY_DRAFTS_KEY, type: "all" }),
                qc.refetchQueries({ queryKey: ME_KEY, type: "all" }),
            ]);
        },
    });

    return { create, rename, remove };
}
